import { FC } from 'react';

import { useConfigContext } from '../../context/ConfigContext';
import { H1 } from '../heading/Hx';
import { CONFIG } from './config';
import { StyledImage, StyledWrapper } from './styled';
import { PageImageId } from './type';

type PageImageProps = {
  id: PageImageId;
};

const PageImage: FC<PageImageProps> = ({ id }) => {
  const { company } = useConfigContext();

  const { subtitle, sxH1, sxImage, sxWrapper, title } = CONFIG[id];

  const titleEl = title ? (
    <span dangerouslySetInnerHTML={{ __html: title.replace('#COMPANY#NAME', company.name) }} />
  ) : undefined;

  return (
    <StyledWrapper sx={sxWrapper}>
      <StyledImage sx={sxImage}>
        <H1 margin='0' sx={sxH1} uppercase>
          {titleEl}
          {titleEl && subtitle && <br />}
          {subtitle}
        </H1>
      </StyledImage>
    </StyledWrapper>
  );
};

export default PageImage;
